import { Component, OnInit } from '@angular/core';
import { ProductService } from 'src/app/components/shared/services/product.service';
import { ActivatedRoute, Params } from '@angular/router';
import { Product, ColorFilter } from 'src/app/modals/product.model';
import { FormBuilder, FormGroup, FormControl } from '@angular/forms'
import { Router } from '@angular/router';
import { MatExpansionPanel } from '@angular/material/expansion';
import { ViewportScroller } from '@angular/common';
import { ChangeDetectorRef, NgZone } from '@angular/core';
import { ScrollPositionService } from '../../../shared/services/ScrollPosition.service';
@Component({
  selector: 'app-product-left-sidebar',
  templateUrl: './product-left-sidebar.component.html',
  styleUrls: ['./product-left-sidebar.component.sass']
})
export class ProductLeftSidebarComponent implements OnInit {
  public sidenavOpen: boolean = true;
  public animation: any; // Animation
  public sortByOrder: string = ""; // sorting
  public page: any;
  public tagsFilters: any[] = [];
  public viewType: string = "grid";
  public viewCol: number = 25;
  public filterForm: FormGroup;
  public colorFilters: ColorFilter[] = [];
  public items: Product[] = [];
  public allItems: Product[] = [];
  public products: Product[] = [];
  public allItemsInitial: Product[] = [];
  public tags: any[] = [];
  public colors: any[] = [];
  public getValue: any;
  public initialSearchParam: string;
  public initialBrandParam: string;
  enteredSearchValue: string = "";
  public name: Product[] = [];
  public currentScrollPosition: [number, number] = [0, 0];
  public currentPage: number = 1;
  private searchTimeout = null;

  togglePanel(panel: MatExpansionPanel) {
    panel.toggle();
  };

  constructor(  private productService: ProductService,
    private route: ActivatedRoute,
    private router: Router,
    private viewportScroller: ViewportScroller,
    private ngZone: NgZone,
    private cdr: ChangeDetectorRef,
    private scrollPositionService: ScrollPositionService) {
      console.log('current scroll', this.currentScrollPosition);
      this.route.params.subscribe((params: Params) => {
        const category = params["category"];
    
        if (category) {
          this.productService.getProducts().subscribe((products) => {
            // Filter out products with price 0 by default
            this.allItemsInitial = products.filter(product => product.price !== 0);
            const filteredProducts = this.allItemsInitial.filter(
              (value) => value.category === category
            );
            this.allItems = category === "all" ? this.allItemsInitial : filteredProducts;
            this.products = this.allItems;
      
    
            this.route.queryParams.subscribe((params: any) => {
              this.initialSearchParam = params.searchParameter || "";
              this.initialBrandParam = params.brandParameter || "";
    
              if (this.initialSearchParam) {
                this.allItems = this.products.filter((item: Product) => {
                  return (
                    item.name
                      .toLowerCase()
                      .indexOf(this.initialSearchParam.toLowerCase()) > -1
                  );
                });
              }
    
              if (this.initialBrandParam) {
                this.allItems = this.products.filter((item: Product) =>
                  Number(item.brandId) === Number(this.initialBrandParam)
                );
              }
            });
    
            // Restore the page and scroll position
            this.scrollPositionService.getScrollPosition().subscribe((position) => {
              this.ngZone.runOutsideAngular(() => {
                setTimeout(() => {
                  this.waitForRenderComplete(() => {
                    window.scrollTo({ top: position, behavior: 'smooth' });
                  });
                }, 1000);
              });
            });
    
            this.scrollPositionService.getCurrentPage().subscribe((page) => {
              this.page = page;  // Restore current page
              this.currentPage = page;
            });
          });
        }
      });
    
  }

  private waitForRenderComplete(callback: () => void) {
    let checkRenderInterval = setInterval(() => {
      if (document.readyState === 'complete') {
        clearInterval(checkRenderInterval);
        callback();
      }
    }, 100);
  }

  public handleSearchChange(event) {
    const searchParam = event.target.value?.toLocaleLowerCase();

    //console.log("Key up", searchParam);

    clearTimeout(this.searchTimeout);

    this.searchTimeout = setTimeout(() => {
      this.allItems = this.allItemsInitial.filter((product) => {
        const productName = product.name?.toLocaleLowerCase();
        return (product.price !== 0) &&  // Add price check
               (searchParam === "" || productName.indexOf(searchParam) > -1);
      });
      this.products = this.allItems;
      // console.log(this.products,'sad') 
    }, 100);
  }

     // Get current product tags
     public getTags(products) {
      var uniqueBrands = []
      var itemBrand = Array();
      products.map((product, index) => {
         if(product.tags) {
            product.tags.map((tag) => {
            const index = uniqueBrands.indexOf(tag);
            if(index === -1)  uniqueBrands.push(tag);
         })
        }
      });
      for (var i = 0; i < uniqueBrands.length; i++) {
           itemBrand.push({brand:uniqueBrands[i]})
      }
      this.tags = itemBrand
   }

     // Get current product colors
     public getColors(products) {
      var uniqueColors = []
      var itemColor = Array();
      products.map((product, index) => {
        if(product.colors) {
        product.colors.map((color) => {
            const index = uniqueColors.indexOf(color);
            if(index === -1)  uniqueColors.push(color);
        })
       }
      });
      for (var i = 0; i < uniqueColors.length; i++) {
           itemColor.push({color:uniqueColors[i]})
      }
      this.colors = itemColor
   }

  ngOnInit() {
    
  }



  public changeViewType(viewType, viewCol){
    this.viewType = viewType;
    this.viewCol = viewCol;
  }
    // Animation Effect fadeIn
    public fadeIn() {
      this.animation = 'fadeIn';
  }

  // Animation Effect fadeOut
  public fadeOut() {
      this.animation = 'fadeOut';
  }

    // Update tags filter
    public updateTagFilters(tags: any[]) {
      this.tagsFilters = tags;
      this.animation == 'fadeOut' ? this.fadeIn() : this.fadeOut(); // animation
  }



    // sorting type ASC / DESC / A-Z / Z-A etc.
    public onChangeSorting(val) {
      this.sortByOrder = val;
      this.animation == 'fadeOut' ? this.fadeIn() : this.fadeOut(); // animation
   }

     // Initialize filetr Items
  public filterItems(): Product[] {
    return this.items.filter((item: Product) => {
        const Colors: boolean = this.colorFilters.reduce((prev, curr) => { // Match Color
          if(item.colors){
            if (item.colors.includes(curr.color)) {
              return prev && true;
            }
          }
        }, true);
        const Tags: boolean = this.tagsFilters.reduce((prev, curr) => { // Match Tags
          if(item.tags) {
            if (item.tags.includes(curr)) {
              return prev && true;
            }
          }
        }, true);
        return Colors && Tags; // return true
    });

}

public onPageChanged(event) {
  this.page = event;
  this.currentPage = event;
  this.allItems;
  window.scrollTo(0, 0);
}


  // Update price filter
//   public updatePriceFilters(price: any) {
//     let items: any[] = [];
//     this.products.filter((item: Product) => {
//         if (item.price >= price[0] && item.price <= price[1] )  {
//            items.push(item); // push in array
//         }
//     });
//     this.items = items;
// }


  // Update price filter
  public updatePriceFilters(price: any) {
    this.allItems = this.products.filter((item: Product) => {
      return item.price !== 0 &&  // Keep this filter
             item.price >= price.priceFrom && 
             item.price <= price.priceTo;
    });
  }

onBrendsChanged(newBrend) {
  this.allItems = (newBrend === "all")
    ? this.allItemsInitial
    : this.allItemsInitial.filter(
      (item: any) => item.brand === newBrend.nazivProizvodjaca && item.price !== 0
    );
  this.products = this.allItems;
}
}
